import React from 'react';
import PropTypes from 'prop-types';

import FullWidthContainer from 'components/consumer/FullWidthContainer';
import LogoLink from 'components/consumer/LogoLink';
import HeaderToolbar from 'components/nav/shared/HeaderToolbar';
import ConsumerSearchBar from 'components/consumer/consumer-search/ConsumerSearchBar';
import BrowserOnly from 'components/consumer/BrowserOnly';
import DesktopNavCategories from '../DesktopNavCategories';

const DesktopPrimaryNav = ({ selectedCategoryId, setIsLinkHovered }) => (
  <FullWidthContainer>
    <FullWidthContainer
      className="items-center flex justify-between max-[1023px]:z-11 lg:!z-[1003] relative bg-white"
      data-xc="DesktopPrimaryNav"
      hasPadding
    >
      <LogoLink />

      <DesktopNavCategories
        selectedCategoryId={selectedCategoryId}
        setIsLinkHovered={setIsLinkHovered}
      />
      <HeaderToolbar />
    </FullWidthContainer>

    <BrowserOnly>
      <FullWidthContainer>
        <ConsumerSearchBar />
      </FullWidthContainer>
    </BrowserOnly>
  </FullWidthContainer>
);

DesktopPrimaryNav.propTypes = {
  selectedCategoryId: PropTypes.string,
  setIsLinkHovered: PropTypes.func,
};

export default DesktopPrimaryNav;
